export const HOSTNAME = 'https://cherryxtrfy.com'
